<img [src]="imageSource" [alt]="altText" />
